var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 19.75,
    height: 29.0714,
    rx: 5,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1072,
    y: 5.10718,
    width: 15.5357,
    height: 20.5071,
    rx: 3,
    fill: "#C7DFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9714,
    y: 27.4785,
    width: 11.8071,
    height: 1.86429,
    rx: 0.932143,
    fill: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4148 14.8903L19.2207 10.2262C19.0441 10.0294 18.7048 10.0294 18.5282 10.2262L14.334 14.8903C14.2736 14.9573 14.234 15.0404 14.2199 15.1295C14.2059 15.2186 14.218 15.3098 14.2548 15.3922C14.3293 15.5606 14.4962 15.6688 14.6802 15.6688H15.6123V18.9336C15.6123 19.0573 15.6614 19.176 15.7488 19.2634C15.8362 19.3509 15.9547 19.4 16.0783 19.4H17.4764C17.6 19.4 17.7185 19.3509 17.8059 19.2634C17.8933 19.176 17.9424 19.0573 17.9424 18.9336V17.068H19.8065V18.9336C19.8065 19.0573 19.8556 19.176 19.943 19.2634C20.0303 19.3509 20.1489 19.4 20.2725 19.4H21.6705C21.7941 19.4 21.9127 19.3509 22.0001 19.2634C22.0875 19.176 22.1366 19.0573 22.1366 18.9336V15.6688H23.0686C23.1588 15.6691 23.2473 15.6432 23.3231 15.5942C23.3989 15.5452 23.4588 15.4751 23.4955 15.3926C23.5322 15.3101 23.5441 15.2187 23.5298 15.1295C23.5155 15.0403 23.4755 14.9572 23.4148 14.8903Z",
    fill: "#6CA5D4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits2);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-2.00b6be62b349c693361976d8424d3f14.svg";
export { ForwardRef as ReactComponent };